function SeparatorOption() {
  return <div className='MenuOption MenuSeparator menu-separator' />;
}

export default SeparatorOption;
